<i18n>
{
  "cl": {
    "operationsLabel": "Operaciones de ",
    "operationLabel": "Operación",
    "messageObtainOperations": "Ocurrió un error al obtener la operaciones de este cliente",
    "search": "Buscar cliente"
  },
  "pe": {
    "operationsLabel": "Operaciones de ",
    "operationLabel": "Operación",
    "messageObtainOperations": "Ocurrió un error al obtener la operaciones de este cliente",
    "search": "Buscar cliente"
  },
  "br": {
    "operationsLabel": "Operações de ",
    "operationLabel": "Operação",
    "messageObtainOperations": "Ocorreu um erro ao obter as operações deste cliente",
    "search": "Encontrar cliente"
  }
}
</i18n>
<template>
  <div>
    <Spinner id="spinner" :is-loading="isLoading" />
    <div v-if="!isLoading" class="card-item">
      <div>
        <b-field class="m-5">
          <FindEntitiesInput
            id="find-clients-input"
            :placeholder="$t('search')"
            :expanded="true"
            :finder="finder"
            class="search-clients"
            @select="clickedOnClient($event)" />
        </b-field>
      </div>
      <div v-if="client">
        <div v-if="errorGettingClientOperations.fail">
          {{ errorGettingClientOperations.message }}
        </div>
        <div v-if="clientOperations.length>0">
          <h3>{{ $t('operationsLabel') }} {{ client.name }}</h3>
          <div class="operations-list">
            <div v-for="operation in clientOperations" :key="operation._id" class="card-item">
              <div class="operation-header">
                <span>{{ $t('operationLabel') }} {{ operation.companyOperationId }}</span>
                <a :id="`extend-${operation.companyOperationId}`" href="#" @click="setSelectedOperation(operation.companyOperationId)">
                  <span class="fa" :class="operation.companyOperationId===selectedOperation ? 'fa-minus-circle' : 'fa-plus-circle'" />
                </a>
              </div>
              <OperationModifier
                v-if="operation.companyOperationId===selectedOperation"
                :operation="operation"
                @cap-modification="refreshClient" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from '@/ui/components/Spinner.vue';
import FindEntitiesInput from '@/ui/components/internal/FindEntitiesInput.vue';
import OperationModifier from '@/ui/components/internal/settings/OperationModifier.vue';
import { getOperationsByClientId } from '@/application/services/api-clients/operations';
import { findClientsBySearchString } from '@/application/services/api-clients/clients';

export default {
  name: 'Operations',
  components: { Spinner, FindEntitiesInput, OperationModifier },
  data() {
    return {
      isLoading: true,
      expandedCountry: '',
      countryDictionary: { cl: 'Chile', pe: 'Peru', br: 'Brasil' },
      client: null,
      clientOperations: [],
      errorGettingClientOperations: {
        fail: false,
        message: this.$t('messageObtainOperations')
      },
      selectedOperation: undefined,
      finder: findClientsBySearchString
    };
  },
  watch: {
    client(newVal) {
      if (!newVal) {
        this.clientOperations = [];
        this.errorGettingClientOperations.fail = false;
        this.selectedOperation = null;
      }
    }
  },
  async mounted() {
    this.isLoading = false;
  },
  methods: {
    async clickedOnClient(client) {
      try {
        this.errorGettingClientOperations.fail = false;
        this.selectedOperation = null;
        this.clientOperations = await getOperationsByClientId(client._id);
      } catch (_error) {
        this.errorGettingClientOperations.fail = true;
      }
      this.client = client;
    },
    setSelectedOperation(companyOperationId) {
      this.selectedOperation = this.selectedOperation === companyOperationId ? null : companyOperationId;
    },
    async refreshClient() {
      this.selectedOperation = null;
      await this.clickedOnClient(this.client);
    }
  }
};
</script>
<style>
.rotate {
  transform: rotate(180deg);
}
.search-clients {
  margin: auto;
}
.settings-operations-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  place-items: center;
  margin-bottom: 2rem;
}
.settings-operations-header h2 {
  justify-self: start;
}
.operations-list {
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;
}
.operation-header {
  display: grid;
  grid-template-columns: 1fr 2rem;
  place-items: center;
}
.operation-header span {
  justify-self: start;
}
.operation-header a {
  justify-self: end;
}
</style>
